<template>
  <frontoffice-frame :background="false" class="booking-seminar">
    <form-base type="seminar"
               page-title="seminar.form.title"
               :form-data="seminarData"
               :callbacks="{ seminar: onConfirm }"
               :default-submit-button="false"
               invoked-submit-button-name="seminar"
               :disable-submit-button="true"
               @submit="onSubmit"
               @success="onSuccess"
               @failure="onFailure"
    >
      <date-range class="dates" v-model="seminarData.dates" :can-last-the-day="true"
                  v-on:input="setRequestMaxDate" ref="dates"
                  :from="{name: 'starting_date', label: 'seminar.form.dates.from'}"
                  :to="{name: 'ending_date', label: 'seminar.form.dates.to'}"
                  :submitted="trySubmit"
      />

      <text-input class="destination" faClass="map-marker" ref="destination"
                  label="seminar.form.destination.label" name="destination"
                  placeholder="seminar.form.destination.placeholder"
                  v-model="seminarData.destination"
      />

      <event-type class="row" v-model="seminarData.event" ref="event" />

      <number-input class="people" faClass="user-friends" ref="people"
                    label="seminar.form.people.label" name="people"
                    placeholder="seminar.form.people.placeholder"
                    v-model="seminarData.people"
      />

      <radio-input class="accomodation" faClass="hotel" ref="accomodation"
                   label="seminar.form.accomodation.label" name="accomodation"
                   v-model="seminarData.accomodation"
                   @input="updateBedroomsDisplay"
      />

      <bedrooms-repartition class="row" v-show="displayBedrooms" ref="bedrooms"
                            v-model="seminarData.bedrooms" :required="false"
                            label="seminar.form.bedrooms.label"
      />

      <text-area-input class="extra" label="seminar.form.extra.label" ref="extra"
                       name="extra" v-model="seminarData.extra" :required="false"
      />

      <text-input class="budget" faClass="euro-sign" ref="budget"
                  label="seminar.form.budget.label" v-model="seminarData.budget"
                  placeholder="seminar.form.budget.placeholder" name="budget"
      />

      <date-input class="row request" label="seminar.form.request.label"
                  placeholder="seminar.form.request.placeholder" name="request"
                  v-model="seminarData.requestDate" :max-date="requestMaxDate"
                  ref="requestDate" :required="false"
      />

      <div class="submitForm centered-button">
        <submit-button name="seminar" class="btn" @click="trySubmit = true"
                       :disabled="submitted"
        />
      </div>
    </form-base>
  </frontoffice-frame>
</template>

<script>
import frontofficeFrame from '@/components/frontoffice/frame'
import dateRange from '@/components/frontoffice/form/baseInput/dateRange'
import dateInput from '@/components/frontoffice/form/baseInput/date'
import textInput from '@/components/frontoffice/form/baseInput/text'
import numberInput from '@/components/frontoffice/form/baseInput/number'
import radioInput from '@/components/frontoffice/form/baseInput/radio'
import textAreaInput from '@/components/frontoffice/form/baseInput/textArea'
import bedroomsRepartition from '@/components/frontoffice/form/bedroomsRepartition'
import eventType from '@/components/frontoffice/form/eventType'
import formBase from '@/components/frontoffice/form/base'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import submitButton from '@/components/frontoffice/form/baseInput/submit'

export default {
  components: {
    frontofficeFrame,
    dateRange,
    dateInput,
    textInput,
    numberInput,
    radioInput,
    textAreaInput,
    bedroomsRepartition,
    eventType,
    formBase,
    submitButton
  },

  mixins: [formMethods],

  data () {
    return {
      seminarData: {
        dates: {
          from: null,
          to: null
        },
        destination: null,
        event: null,
        people: null,
        accomodation: 'no',
        bedrooms: {
          single: 0,
          double: 0
        },
        extra: null,
        budget: null,
        requestDate: null
      },
      requestMaxDate: new Date(),
      displayBedrooms: false,
      trySubmit: false,
      submitted: false
    }
  },

  methods: {
    updateBedroomsDisplay (selectedValue) {
      this.displayBedrooms = selectedValue === 'yes'
    },

    setRequestMaxDate (maxDate) {
      this.requestMaxDate = maxDate.from || maxDate.to
    },

    onConfirm (data) {
      this.$router.push({
        name: 'offline_request_confirm'
      })
    },

    onSubmit () {
      this.submitted = true
    },

    onSuccess () {
      this.submitted = true
    },

    onFailure () {
      this.submitted = false
    }
  }
}
</script>
